import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { PricingCards } from './PricingCards';
export function FinalCtaSection() {
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-65" data-mp="3quuiexu8fltj">
      <div className="mx-auto max-w-6xl px-4" data-id="element-66" data-mp="3vt5r358sjqa6">
        <div className="mx-auto max-w-2xl text-center" data-id="element-67" data-mp="3vrumj37iuei0">
          <Countdown label="⏰ El precio cierra en:" data-id="element-68" data-mp="2y5na574z7hv3" />
        </div>

        <div className="mt-12" data-id="element-69" data-mp="333yitejjbmbq">
          <PricingCards compact data-id="element-70" data-mp="3335mz8m46h8d" />
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/60" data-id="element-71" data-mp="331uj78so59h9">
          <span className="inline-flex items-center gap-1.5" data-id="element-72" data-mp="3ctrt8c7xxvee">
            <LockIcon className="h-4 w-4 text-[var(--olive-light)]" aria-hidden="true" data-id="element-73" data-mp="3cvb8q0lrw2f4" />
            Pago 100% seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-74" data-mp="2kdh4wg3d2vaf">
            <ZapIcon className="h-4 w-4 text-[var(--olive-light)]" aria-hidden="true" data-id="element-75" data-mp="2kbwbitss9ie5" />
            Acceso en 5 minutos
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-76" data-mp="28cx7h9bvv6th">
            <ShieldCheckIcon className="h-4 w-4 text-[var(--olive-light)]" aria-hidden="true" data-id="element-77" data-mp="28dfb4r0vknbf" />
            Garantía 7 días
          </span>
        </div>
        <p className="mt-3 text-center text-sm text-white/50" data-id="element-78" data-mp="1yndq683tjl0q">
          💳 Mercado Pago · Tarjeta · Transferencia
        </p>
      </div>
    </section>;
}